import axios from 'axios'

const endpoint = `${window.env && window.env.baseHost}/api/boitata/v1/zipcode`

export const getSuggestion = (city) =>
  axios.get(`${endpoint}/city/${city}`)

export const getZipCode = (zipcode) =>
  axios.get(`${endpoint}/${zipcode}`)
